import {
  useState,
  useCallback,
  createContext,
  useContext,
  ReactNode,
  ReactElement,
} from 'react';

interface IPlayVideoProviderContextProps {
  fullScreenAndPlay: boolean;
  setMediaPlayMode: (value: boolean) => void;
}

const PlayVideoProviderContextProps =
  createContext<IPlayVideoProviderContextProps>({
    fullScreenAndPlay: false,
    setMediaPlayMode: () => {},
  });

const PlayVideoProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const [fullScreenAndPlay, setfullScreenAndPlay] = useState(false);

  const setMediaPlayMode = useCallback(
    (value: boolean) => {
      setfullScreenAndPlay(value);
    },
    [fullScreenAndPlay],
  );

  return (
    <PlayVideoProviderContextProps.Provider
      value={{
        fullScreenAndPlay,
        setMediaPlayMode,
      }}
    >
      {children}
    </PlayVideoProviderContextProps.Provider>
  );
};

const usePlayMedia = () => useContext(PlayVideoProviderContextProps);

export { PlayVideoProvider, usePlayMedia };
